import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// App-wide safety net: a render error in any page (e.g. unexpected/malformed
// data) shows a friendly fallback instead of a blank white screen. The
// "Reload" action is a full navigation so the boundary state resets cleanly.
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-cream flex items-center justify-center px-6">
          <div className="text-center max-w-md">
            <p className="font-display text-2xl text-amber mb-2">Rankum</p>
            <h1 className="font-display text-3xl text-charcoal mb-4">
              Something went wrong
            </h1>
            <p className="text-charcoal-light mb-6">
              An unexpected error occurred. Reloading usually fixes it.
            </p>
            <a href="/" className="btn-primary justify-center">
              Reload Rankum
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
